import React, { useRef, useEffect, useState } from "react";
import TypingEffect from "../VideoComponent/TypingEffect";
import "./ModernSection_1.css";

const ModernSection = ({ title, quote, paragraph }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`info-card-section${isVisible ? " show" : ""}`}
      aria-labelledby="section-title"
    >
      <div className={`info-card${isVisible ? " show" : ""}`}>
        <div id="section-title" className="mb-2">
          <TypingEffect text={title} />
        </div>
        <blockquote className="info-card-quote">{quote}</blockquote>
        <p className="info-card-desc">{paragraph}</p>
        <div className="info-card-decor1" />
        <div className="info-card-decor2" />
      </div>
    </section>
  );
};

export default ModernSection;
